import { CollapsibleBox, MutedBox, PostSectionTitle } from './post.section-components';

import type { Post } from '@/entities/post/types';
import { isValidArray } from '@/shared/utils/is-valid-array';

export const VideoSummary = ({ post }: { post: Post }) => {
  const isEntityEmpty =
    !isValidArray(post.entity?.brands) &&
    !isValidArray(post.entity?.themes) &&
    !isValidArray(post.entity?.products);

  const isVideoSummaryEmpty = !post.analyzation?.video_summary;
  if (isVideoSummaryEmpty && isEntityEmpty) return null;
  return (
    <MutedBox className="flex flex-col">
      <CollapsibleBox trigger={<PostSectionTitle>Video summary</PostSectionTitle>} initialOpen>
        <div className="flex flex-col gap-6">
          {!isVideoSummaryEmpty && (
            <div className="text-muted-foreground min-w-0 pt-6 text-base font-medium break-words break-keep">
              {post.analyzation?.video_summary}
            </div>
          )}
          {!isEntityEmpty && (
            <div className="flex flex-wrap gap-2.5">
              {post.entity?.themes?.map((theme) => (
                <ThemesBadge key={theme} icon={null} category="Theme" value={theme} />
              ))}
              {post.entity?.brands?.map((brand) => (
                <ThemesBadge key={brand} icon="🏷️" category="Brand" value={brand} />
              ))}
              {post.entity?.products?.map((product) => (
                <ThemesBadge key={product} icon="📦" category="Product" value={product} />
              ))}
            </div>
          )}
        </div>
      </CollapsibleBox>
    </MutedBox>
  );
};

const ThemesBadge = ({
  icon,
  category,
  value,
}: {
  icon: React.ReactNode;
  category: string;
  value: string;
}) => {
  return (
    <div className="flex h-9 items-center gap-1.5 rounded-full border bg-white px-4">
      {icon}
      <span className="text-muted-foreground text-base font-semibold">{category}</span>
      <span className="text-muted-foreground text-base">{value}</span>
    </div>
  );
};
